import { render, staticRenderFns } from "./LatestPagesListItem.vue?vue&type=template&id=b87f3bee&scoped=true&"
import script from "./LatestPagesListItem.vue?vue&type=script&lang=js&"
export * from "./LatestPagesListItem.vue?vue&type=script&lang=js&"
import style0 from "./LatestPagesListItem.vue?vue&type=style&index=0&id=b87f3bee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87f3bee",
  null
  
)

export default component.exports